(function ($, window, undefined) {

    function LocationMapToggle(args) {
        this.defaults = {
            selectors: {
                widgetContainer: "[data-toggle-animation]",
                listBtn: "[data-toggle-first-block]",
                mapBtn: "[data-toggle-second-block]",
                list: "[data-first-block]",
                map: "[data-second-block]"
            },
            classes : {
                animationClass: "toggle-active",
            }
        };

        this.options = $.extend(true, {}, this.defaults, args);
        this.$widgetContainer = $(this.options.selectors.widgetContainer);

        this.$listBtn = this.parent(this.options.selectors.listBtn);
        this.$mapBtn = this.parent(this.options.selectors.mapBtn);
        this.$list = this.parent(this.options.selectors.list);
        this.$map = this.parent(this.options.selectors.map);

        this.init()
    }

    /**
     * Returns a jQuery element that is a child of the parent element
     * @param selector
     * @returns {*|HTMLElement}
     */
    LocationMapToggle.prototype.parent = function (selector) {
        return $(selector, this.$widgetContainer);
    };

    LocationMapToggle.prototype.init = function () {
        var self = this;

        self.toggleDisplay(this.$listBtn, self.$map[0], self.$list[0]);
        self.toggleDisplay(this.$mapBtn, self.$map[0], self.$list[0]);
    };

    LocationMapToggle.prototype.toggleDisplay = function (toggleBtn, firstToggledItem, secondToggledItem) {
        var self = this;

        toggleBtn.on("change", function(){
            firstToggledItem.classList.toggle(self.options.classes.animationClass)
            secondToggledItem.classList.toggle(self.options.classes.animationClass)
        });
    };

    window.SVHA = window.SVHA || {};
    window.SVHA.Widgets = window.SVHA.Widgets || {};
    window.SVHA.Widgets.LocationMapToggle = LocationMapToggle;

})(jQuery, window);



